import React from 'react'
import AppRouter from '../../route/AppRoute'

const App = () => (
    <AppRouter />        
)

export default App
